import { render, staticRenderFns } from "./EditMyProducts.vue?vue&type=template&id=242fcea7"
import script from "./EditMyProducts.vue?vue&type=script&lang=js"
export * from "./EditMyProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports